import { graphql, Link, useStaticQuery } from "gatsby"
import React from "react"
import * as R from "ramda"
import { useMicroCopySv } from "../../hooks/microCopy/sv"
import { useMicroCopyEn } from "../../hooks/microCopy/en"
import { useMicroCopyFi } from "../../hooks/microCopy"
import GetMicroCopy from "../../shared/getMicroCopy"
// import { BgImage } from "gbimage-bridge"

import Logo from "../../images/logo_footer 1.svg"
import LogoSv from "../../images/logo_sv_white.svg"
import LogoEn from "../../images/logo_footer 1.svg"

import LogoIdeapark from "../../images/logo_ideapark.png"

import HouseSilhouette from "../../images/house_silhouette.svg"

import Grid from "@material-ui/core/Grid"
import Button from "@material-ui/core/Button"

import * as styles from "./footer.module.scss"


const Footer = ({language}) => {
  // UI texts
  const microCopyTexts = language === 'sv' ? useMicroCopySv : language === 'en' ? useMicroCopyEn : useMicroCopyFi
  const labelNewsletterTitle = GetMicroCopy(
    microCopyTexts,
    "uutiskirjePopUpOtsikko"
  )
  const labelNewsletterText = GetMicroCopy(
    microCopyTexts,
    "uutiskirjePopUpTeksti"
  )
  const labelNewsletterCta = GetMicroCopy(microCopyTexts, "uutiskirjeTilaa")
  const labelCookieSettings = GetMicroCopy(microCopyTexts, "evästeAsetukset")
  // end UI texts

  const footerQuery = useStaticQuery(graphql`
    query footerQuery {
      primary: contentfulNavigaatio(name: { eq: "Alanavigaatio" }, node_locale: { eq: "fi" }) {
        name
        links {
          id
          key
          value
        }
      }
      secondary: contentfulNavigaatio(name: { eq: "Apunavigaatio" }, node_locale: { eq: "fi" }) {
        name
        links {
          id
          key
          value
        }
      }
      primarySv: contentfulNavigaatio(name: { eq: "Alanavigaatio" }, node_locale: { eq: "sv" }) {
        name
        links {
          id
          key
          value
        }
      }
      secondarySv: contentfulNavigaatio(name: { eq: "Apunavigaatio" }, node_locale: { eq: "sv" }) {
        name
        links {
          id
          key
          value
        }
      }
      primaryEn: contentfulNavigaatio(name: { eq: "Alanavigaatio" }, node_locale: { eq: "en" }) {
        name
        links {
          id
          key
          value
        }
      }
      secondaryEn: contentfulNavigaatio(name: { eq: "Apunavigaatio" }, node_locale: { eq: "en" }) {
        name
        links {
          id
          key
          value
        }
      }
      siteDetailsFi: allContentfulSiteDetail(filter: {node_locale: { eq: "fi" }}) {
        edges {
          node {
            value
            spacer
            order
          }
        }
      }
      siteDetailsSv: allContentfulSiteDetail(filter: {node_locale: { eq: "sv" }}) {
        edges {
          node {
            value
            spacer
            order
          }
        }
      }
      siteDetailsEn: allContentfulSiteDetail(filter: {node_locale: { eq: "en" }}) {
        edges {
          node {
            value
            spacer
            order
          }
        }
      }
      allContentfulIcon: allContentfulIcon(filter: {node_locale: { eq: "fi" }}) {
        nodes {
          href
          file {
            file {
              url
            }
          }
        }
      }
      vector: file(relativePath: { eq: "shape_footer_corner.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100)
        }
      }
    }
  `)
  const siteDetails = language === 'sv' ? footerQuery.siteDetailsSv.edges : language === 'en' ? footerQuery.siteDetailsEn.edges : footerQuery.siteDetailsFi.edges;
  const navItems = language === 'sv' ? footerQuery.primarySv.links : language === 'en' ? footerQuery.primaryEn.links : footerQuery.primary.links
  const subNavItems = language === 'sv' ? footerQuery.secondarySv.links : language === 'en' ? footerQuery.secondaryEn.links : footerQuery.secondary.links

  // const vectorImage = R.path(
  //   ["childImageSharp", "gatsbyImageData"],
  //   footerQuery.vector
  // )

  const footerLanguageConfig = {
    fi: {
      containerClassName: styles.footerContainer,
      logoAlt: "Asuntomessut",
      logoSrc: Logo,
      logoStyle: {
        width: "258px",
        height: "164px",
        margin: "0 auto",
      },
      showSocialIcons: true,
      newsletterEnabled: true,
      ideaparkUrl: "https://lempaala.ideapark.fi/",
      ideaparkTitle: "Pääyhteistyökumppani",
    },
    sv: {
      containerClassName: styles.footerContainerSv,
      logoAlt: "Bostadsmassan",
      logoSrc: LogoSv,
      logoStyle: {
        width: "258px",
        height: "auto",
        margin: "0 auto",
      },
      showSocialIcons: false,
      newsletterEnabled: false,
      ideaparkUrl: "",
      ideaparkTitle: "Pääyhteistyökumppani"
    },
    en: {
      containerClassName: styles.footerContainerEn,
      logoAlt: "Housing Fair",
      logoSrc: LogoEn,
      logoStyle: {
        width: "258px",
        height: "auto",
        margin: "0 auto",
      },
      showSocialIcons: false,
      newsletterEnabled: false,
      ideaparkUrl: "https://lempaala.ideapark.fi/en/",
      ideaparkTitle: "Pääyhteistyökumppani"
    },
  }

  const currentFooterConfig = footerLanguageConfig[language] || footerLanguageConfig.fi

  const renderSiteDetails = () => {
    const sortedSiteDetails = siteDetails
      .filter(({ node }) => node.value !== null) // Skip the empty/null details
      .sort((a, b) => a.node.order - b.node.order);
    return sortedSiteDetails.map(({ node }, index) => {
      let separator;

      switch (node.spacer) {
        case 'br':
          separator = <br />;
          break;
        case 'space':
          separator = <> <br /> <br /> </>;
          break;
        default:
          separator = null;
      }

      return (
        <React.Fragment key={index}>
          <text style={{ fontSize: "15px" }}>
            {node.value}
            {separator}
          </text>
        </React.Fragment>
      );
    });
  }

  const renderNavigationItems = () => {
    if (!navItems) {
      return null
    }

    return (
      <nav className={styles.nav}>
        {navItems.map(item => (
          <div
            className={styles.linkContainer}
            key={R.path(["key"], item)}
          >
            {R.path(["value"], item) && (
              <Link
                to={`${R.path(["value"], item)}`}
                key={`${R.path(["id"], item)}`}
                partiallyActive={true}
                activeClassName={styles.active}
                className="footer-black"
                activeStyle={{ borderBottomColor: "#69d2fa" }}
              >
                {R.path(["key"], item)}
              </Link>
            )}
          </div>
        ))}
      </nav>
    )
  }

  const renderSocialIcons = () => {
    if (!currentFooterConfig.showSocialIcons || !footerQuery?.allContentfulIcon?.nodes) {
      return null
    }

    return (
      <Grid container spacing={0} direction="row" style={{ maxWidth: "200px", margin: "0 auto", padding: "0 40px" }}>
        {footerQuery.allContentfulIcon.nodes.map((node, index) => (
          <Grid item xs key={index}>
            <a target="_blank" rel="noreferrer" href={node.href}>
              <img src={node?.file?.file?.url} alt="" />
            </a>
          </Grid>
        ))}
      </Grid>
    )
  }

  // Copyright
  const currentYear = new Date().getFullYear();
  const copyright = {
    fi: `© Osuuskunta Suomen Asuntomessut ${currentYear}. Kaikki oikeudet pidätetään.`,
    sv: `© Andelslaget Finlands Bostadsmässa ${currentYear}. Alla rättigheter förbehålls.`,
    en: `© Cooperative Finnish Housing Fair ${currentYear}. All rights reserved.`,
  };

  const ideaparkImage = (
    <img
      alt="Ideapark"
      src={LogoIdeapark}
      style={{
        width: "200px",
        height: "156px",
        margin: "0 auto",
      }}
    />
  )

  return (
    <footer style={{ overflow: "hidden" }}>

      {currentFooterConfig.newsletterEnabled && (
        <div style={{ backgroundColor: "#69d2fa" }}>
          <div style={{ maxWidth: "1200px", margin: "0 auto", textAlign: "center", padding: "32px 16px" }}>
            <h2 className="footer">{labelNewsletterTitle}</h2>
            <p>{labelNewsletterText}</p>
            <div className={styles.mailListInner}>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://asuntomessut.us6.list-manage.com/subscribe?u=baad3ce0a65ba479b91b56095&id=8f21b6c3f3"
                className="yellow"
              >
                <Button variant="contained" color="primary">
                  {labelNewsletterCta}
                </Button>
              </a>
            </div>
          </div>
        </div>
      )}

      <div className={currentFooterConfig.containerClassName}>
        <Grid container className={styles.columnContainer} spacing={0} direction="row">
          <Grid item className={styles.column1} xs={12} lg={4} xl={4}>
            <div
              style={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <img
                alt={currentFooterConfig.logoAlt}
                src={currentFooterConfig.logoSrc}
                style={currentFooterConfig.logoStyle}
              />
              <div style={{ paddingTop: "24px" }}>
                {renderSiteDetails()}
              </div>
              {renderSocialIcons()}
            </div>
          </Grid>

          <Grid item className={styles.column2} xs={12} lg={4} xl={4}>
            {currentFooterConfig.ideaparkUrl ? (
              <a
                href={currentFooterConfig.ideaparkUrl}
                target="_blank"
                rel="noreferrer"
              >
                {ideaparkImage}
              </a>
            ) : (
              ideaparkImage
            )}
            <div style={{ paddingTop: "6px" }}>
              <span style={{fontSize: "15px" }}>
                {currentFooterConfig.ideaparkTitle}
              </span>
            </div>
          </Grid>

          <Grid item className={styles.column3} xs={12} lg={4} xl={4}>
            {renderNavigationItems()}
          </Grid>
        </Grid>
      </div>

      <div
        style={{
          backgroundColor: "#fff",
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
        }}
      >
        <div className={styles.subnavcontainer}>
          {subNavItems && (
            <nav className={styles.subnav}>
              {subNavItems.map(item => (
                <div
                  className={styles.linkContainer}
                  key={`${R.path(["value"], item)}`}
                >
                  <Link
                    to={`${R.path(["value"], item)}`}
                    key={`${R.path(["id"], item)}`}
                    partiallyActive={true}
                    activeClassName={styles.active}
                    activeStyle={{ borderBottomColor: "#69d2fa" }}
                  >
                    {R.path(["key"], item)}
                  </Link>
                </div>
              ))}
              <button
                className="p-0 !text-black bg-transparent border-solid border-b-2 border-t-0 border-x-0 border-transparent leading-none hover:!border-[#ccc] hover:!text-black cursor-pointer"
                onClick={() => window.Cookiebot?.renew()}
                type="button"
              >
                {labelCookieSettings}
              </button>
            </nav>
          )}

          <div className={styles.copyright}>
            {copyright[language] || copyright.en}
          </div>

        </div>

        <div style={{ position: "absolute", right: "0px" }} className={styles.bg_house}>
          <img
            src={HouseSilhouette}
            className="m-0"
            alt=""
            ariaHidden="true"
          />
        </div>

      </div>
    </footer>
  )
}

export default Footer
